module.exports = __webpack_public_path__ + "media/categories/1057-759ebb9d.svg";